import type { TransitionConfigFunction } from '../types';

export const DEFAULT_INVALID_DOCUMENT_CONFIG: TransitionConfigFunction = (_context) => ({
  title: 'There are issues with the contract',
  content: 'Please fix the validation errors before proceeding.',
  buttons: {
    cancel: false,
    confirm: { text: 'OK' },
  },
  icon: { type: 'danger' },
  validation: { required: true },
});
